import React, { useState, useEffect } from "react";
import Header from "../home/header";
import UTILS from "../../utils/commons"
import feature from "../../img/products.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../home/Loading";
import { ApiClient } from "../../utils/api-client";

const ProductEditForm = ( props ) => {
  let navigate = useNavigate();
  let location = useLocation();
  const params = useParams();
  const productId = params.id;
  const productToEdit = location.state?.product || location.state;
  const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  const storedData = location.state;
  const [ feedback, setFeedback ] = useState( "" );
  const [ isLoading, setIsLoading ] = useState( false );
  const [ newProduct, setNewProduct ] = useState( productToEdit || {} );
  const [ preview, setPreview ] = useState( productToEdit?.image || feature )
  const apiClient = new ApiClient( loginState.accessToken )
  //save product
  const saveProduct = async ( product ) => {

    try {
      const axiosResponse = await apiClient.patch( `products/${productId}`, product );
      console.log( "🚀 ~ saveProduct ~ axiosResponse:", axiosResponse )
      if ( axiosResponse.status === 200 || axiosResponse.status === 201 ) {
        setIsLoading( false );
        navigate( "/products", { replace: true } );
      }
      else setFeedback( "Oops! Something went wrong" );
      setIsLoading( false );
    }
    catch ( err ) {
      console.log( "err: ", err );
      setFeedback( "Oops! Something went wrong" );
      setIsLoading( false );
    }
  }

  const getProductById = async ( pid ) => {
    let prod = storedData?.products?.find( p => p.id === pid );
    if ( !prod ) {
      const productResult = await apiClient.get( `products/${pid}` );
      if ( productResult.status === 200 ) {
        prod = productResult.data;
      }
    }
    setNewProduct( prod || {} );
    setPreview( prod?.image || feature );
  }

  const handleReorderLevelChange = ( e ) => {
    let rl = e.target.value;
    setNewProduct( { ...newProduct, reorderLevel: rl } );
  }
  const handleMaxDiscountChange = ( e ) => {
    const value = Math.min( 100, Math.max( 0, Number( e.target.value || 0 ) ) );
    setNewProduct( { ...newProduct, maxDiscountPercent: value } );
  }
  const handlePackSizeChange = ( e ) => {
    let ps = e.target.value;
    setNewProduct( { ...newProduct, packSize: ps } );
  }
  const handleDescriptionChange = ( e ) => {
    let desc = e.target.value;
    setNewProduct( { ...newProduct, description: desc } );
  }
  const handleProductNameChange = ( e ) => {
    let name = e.target.value;
    setNewProduct( { ...newProduct, productName: name } );
  }
  const handleFileChange = ( e ) => {
    // read file as data URL and update preview
    try {
      if ( !e || !e.target || !e.target.files || !e.target.files[ 0 ] ) return;
      const file = e.target.files[ 0 ];

      // optional: validate file type (image)
      if ( !file.type || !file.type.startsWith( 'image/' ) ) {
        setFeedback( 'Please select a valid image file' );
        return;
      }
      if ( file.size > UTILS.MAX_FILE_SIZE ) {
        setFeedback( `File size exceeds the maximum limit of ${UTILS.MAX_FILE_SIZE / ( 1024 * 1024 )} MB` );
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        // reader.result is a data URL (string)
        setPreview( reader.result );
      };
      reader.onerror = ( err ) => {
        console.error( 'FileReader error:', err );
        setFeedback( 'Failed to read image file' );
        setPreview( feature );
      };

      reader.readAsDataURL( file );
    } catch ( err ) {
      console.error( err );
      setFeedback( 'Failed to process selected file' );
      setPreview( feature );
    }
  }
  const handleSubmit = ( event ) => {
    event.preventDefault();
    setIsLoading( true );
    let file = preview

    let prod = { productName: newProduct.productName, description: newProduct.description, packSize: newProduct.packSize, image: file, reorderLevel: newProduct.reorderLevel, maxDiscountPercent: Number( newProduct.maxDiscountPercent || 0 ) };
    saveProduct( prod );
  }
  useEffect( () => {
    if ( !loginState ) {
      navigate( "/login", { replace: true } );
    }
    else if ( !productToEdit ) {
      getProductById( productId );
    }
  }, [] );

  return (
    <>
      <Header auth={loginState} />
      <section className="container mx-auto mt-8">
        {feedback.length > 0 ? <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="feedback">{feedback}</div> : null}

        <div className="rounded-xl border border-gray-200 bg-white shadow-md p-4 md:p-6">
          <div className="flex items-center justify-between mb-5">
            <div>
              <p className="text-sm uppercase tracking-wide text-gray-500">Product Setup</p>
              <p className="text-2xl font-semibold text-gray-800">Edit Product</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
            <div className="md:col-span-1 rounded-xl border border-gray-200 bg-gray-50 p-4 text-center">
              <img src={preview} alt="Product feature" className="h-36 w-36 rounded-xl object-cover border-2 border-primary-200 mx-auto" />
              <p className="text-sm text-gray-500 mt-3">Image Preview</p>
            </div>
            <div className="md:col-span-2">
              <form id="edit_product_form"
                className="w-full"
                method="post" onSubmit={handleSubmit}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="name" className="text-sm text-gray-600">Product Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      onChange={handleProductNameChange}
                      value={newProduct.productName || ''}
                      placeholder="Product name"
                    />
                  </div>
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="description" className="text-sm text-gray-600">Description</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newProduct.description || ''}
                      onChange={handleDescriptionChange}
                      id="description"
                      name="description"
                      placeholder="Product Description"
                    />
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="pack_size" className="text-sm text-gray-600">Pack Size</label>
                    <select
                      value={newProduct.packSize || '100ML'}
                      onChange={handlePackSizeChange}
                      className="form-control"
                      id="pack_size"
                      name="pack_size">
                      <option>100ML</option>
                      <option>250ML</option>
                      <option>500ML</option>
                      <option>1LT</option>
                      <option value="1KG">1Kg</option>
                      <option value="500G">500g</option>
                    </select>
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="reorder_level" className="text-sm text-gray-600">Reorder Level</label>
                    <input type="number"
                      className="form-control"
                      value={newProduct.reorderLevel || 0}
                      onChange={handleReorderLevelChange}
                      id="reorder_level"
                      name="reorder_level"
                      placeholder="Reorder Level" />
                  </div>
                  <div className="form-group my-1">
                    <label htmlFor="max_discount_percent" className="text-sm text-gray-600">Maximum Discount (%)</label>
                    <input type="number" className="form-control" value={newProduct.maxDiscountPercent || 0} onChange={handleMaxDiscountChange} id="max_discount_percent" min="0" max="100" step="0.01" />
                  </div>
                  <div className="form-group my-1 sm:col-span-2">
                    <label htmlFor="image_file" className="text-sm text-gray-600">Product Image</label>
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="form-control"
                      accept="image/*"
                      id="image_file"
                      name="image_file" />
                  </div>
                </div>
                <div className="form-group mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    {isLoading ? <Loading /> :
                      <input
                        type="submit"
                        className="form-control bg-success"
                        id="btnSubmit"
                        name="btnSubmit"
                        value="SUBMIT"
                      />}
                  </div>
                  <div>
                    <input onClick={() => { navigate( -1 ) }}
                      type="button"
                      className="form-control"
                      value="Cancel"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ProductEditForm;
